export const LeavePolicyPolicyAmountValueTypeConstant = [
  { name: 'Per day percentage of annual average salary', value: 'percentage' },
  { name: 'Extra added with per day salary of annual average salary', value: 'extra_added_with_per_day_salary' },
]
